import styled from "@emotion/styled";
import {
	ListItemButton,
	listItemButtonClasses,
	ListItemText,
	listItemTextClasses,
	styled as muiStyled,
} from "@mui/material";

type ISidebarWrapper = {
	top: number;
	width: number;
};

export const SidebarWrapper = styled.div<ISidebarWrapper>`
	top: ${(props) => props.top}px;
	left: 0;
	width: ${(props) => props.width}px;
	position: sticky;
	height: 100vh;
	background-color: #f7f7f7;
`;

export const SidebarTitle = styled.div`
	font-size: 14px;
	font-weight: bold;
	line-height: 20px;
	padding-left: 36px;
	margin: 54px 0 24px 0;
	max-width: 120px;
	word-break: keep-all;
`;

export const SidebarListItemButton = muiStyled(ListItemButton)`
	padding-left: 36px;
	margin: 0 10px;
	border-radius: 6px;

	&.${listItemButtonClasses.selected} {
		background-color: rgba(196, 196, 196, 0.5);

		&:hover {
			background-color: rgba(196, 196, 196, 0.5);
		}

		.${listItemTextClasses.primary} {
			font-weight: 700;
			color: #000;
		}
	}

	& .MuiTouchRipple-child {
		background-color: #000;
	}
`;

export const SidebarListItemText = muiStyled(ListItemText)`
	.${listItemTextClasses.primary} {
		font-size: 14px;
		color: #888888;
		font-weight: 400;
	}
`;
